<template>
  <div class="">
    <div class="hero-background"></div>
    <div class="gradient-overlay"></div>
    <div class="row d-flex align-items-center justify-content-center vh-100">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
        <Card class="bg-white login-card shadow-lg">
          <div class="card-content p-4">
            <div class="text-center mb-4">
              <img src="../../../public/logo.png" width="100px" alt="logo" class="logo-animation">
              <h2 class="login-title mt-4 mb-1">Employee Sign In</h2>
              <p class="text-muted">Sign in to your account</p>
            </div>

            <div class="mt-5">
              <form @submit.prevent="">
                <div class="row">
                  <div class="form-group col-md-12">
                    <label for="email" class="form-label h6 mt-3">Email address</label>
                    <input type="text" class="form-control form-control-lg" placeholder="Enter your email" v-model="user.email">
                  </div>
                  <div class="form-group col-md-12">
                    <label for="password" class="form-label h6 mt-3">Password</label>
                    <div class="input-group">
                      <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg" placeholder="Enter your password" v-model="user.password">
                      <span class="input-group-text password-toggle" @click="togglePassword">
                        <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-4 mt-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="user.remember" id="rememberMe">
                    <label class="form-check-label" for="rememberMe">Remember me</label>
                  </div>
                  <a href="#" class="text-primary fw-bold" @click.prevent="forgotPassword">Forgot Password?</a>
                </div>
                <button
                    class="btn btn-primary btn-lg w-100 rounded rounded-2"
                    :class="loading ? 'disabled' : ''"
                    @click="loginSubmit"
                >
                  <span v-if="!loading">Sign In</span>
                  <Spinner v-else size="20" stroke="#ffffff" spinner-class="mt-1"/>
                </button>
              </form>
            </div>
          </div>

          <div class="text-center p-3 border-top">
            <p class="mb-0"><a href="javascript:void(0)" class="text-primary fw-bold" @click="goToMainAccounts">Main Accounts</a></p>
          </div>
        </Card>
      </div>
    </div>

    <!-- First Login Modal -->
    <div v-if="showFirstLoginModal">
      <div class="modal fade show" tabindex="-1" style="display: block;" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">First Time Login?</h5>
              <button type="button" class="btn-close" @click="closeFirstLoginModal"></button>
            </div>
            <div class="modal-body">
              <p>To activate your account, please use your <strong>email address</strong> and <strong>ID number</strong> as your password. You will then receive an email with a login password.</p>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="dontShowAgain" v-model="dontShowAgain">
                <label class="form-check-label" for="dontShowAgain">Don't show this again</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="closeFirstLoginModal">Got it</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Backdrop -->
      <div class="modal-backdrop fade show"></div>
    </div>
  </div>
</template>
<script>

import authService from "@/api/authService";
import router from "@/router";
import {decrypt} from "@/utils/crypto";
export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      showPassword: false,
      // Modal related state
      showFirstLoginModal: false,
      dontShowAgain: false
    }
  },

  methods: {
    async loginSubmit() {
      this.loading = true
      await authService.userLogin(this.user)
      this.loading = false
    },
    forgotPassword() {
      router.push('/forgot-password')
    },
    goToMainAccounts() {
      let accounts = process.env.VUE_APP_ACCOUNTS_URL
      window.open(accounts, '_self')
    },
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    // Close modal handler
    closeFirstLoginModal() {
      if (this.dontShowAgain) {
        localStorage.setItem('hideFirstLoginModal', 'true')
      }
      this.showFirstLoginModal = false
    }
  },

  created() {
    let loggedIn = decrypt(sessionStorage.getItem('logged_in')) === 'true'
    if (loggedIn) {
      router.push('/dashboard')
    }
    let next = this.$route.query.next
    let service = this.$route.query.service
    if (next !== undefined) {
      sessionStorage.setItem('next', next)
      sessionStorage.setItem('service', service)
    }
    // Show first-login modal if not previously hidden
    let hideModal = localStorage.getItem('hideFirstLoginModal') === 'true'
    if (!hideModal) {
      this.showFirstLoginModal = true
    }
  },

  computed: {
    user() {
      if (process.env.NODE_ENV === 'development') {
        return {
          email: 'thomasrakwach@gmail.com',
          password: 'password',
          remember: true
        }
      }
      return {
        email: '',
        password: '',
        remember: false
      }
    }
  }
}
</script>

<style scoped>

/* Hero Background */
.hero-background {
  background-image: url('@/assets/img/backgrounds/background.webp');
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  z-index: -2;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0.5) 5%, rgba(0,0,0,0.8) 100%);
  z-index: -1;
}

.login-image {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.login-card {
  border: none;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
}

.login-title {
  font-weight: 700;
  color: #333;
}

.logo-animation {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.card-content {
  padding: 2rem;
}

.password-toggle {
  cursor: pointer;
  background-color: #f8f9fa;
  border-left: none;
}

.password-toggle:hover {
  background-color: #e9ecef;
}

.input-group-text i {
  font-size: 1rem;
  color: #6c757d;
}
</style>
